// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink)
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     const url = new URL(location);
//     if (location.href.indexOf('cartOpen=true') == -1) {
//       url.searchParams.set("cartOpen", "true");
//       window.history.pushState({'cart':'open'}, "", url);
//     }
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {this.classList.add('animate', 'active')});

//     this.addEventListener('transitionend', () => {
//       const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
//       const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//       trapFocus(containerToTrapFocusOn, focusElement);
//     }, { once: true });

//     document.body.classList.add('overflow-hidden');
//   }

//   close() {
//     let currentPageUrl = window.location.href.replace(/[?&]cartOpen=true/g, '');
//     window.history.replaceState({}, document.title, currentPageUrl);
//     this.classList.remove('active');
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove('overflow-hidden');
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//     });

//     cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section => {
//       const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
//       sectionElement.innerHTML =
//           this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
//     }));

//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser()
//       .parseFromString(html, 'text/html')
//       .querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-drawer',
//         selector: '#CartDrawer'
//       },
//       {
//         id: 'cart-icon-bubble'
//       }
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser()
//       .parseFromString(html, 'text/html')
//       .querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.observeCartChanges();
    this.setHeaderCartIconAccessibility();
  }

  observeCartChanges() {
    const observer = new MutationObserver(() => {
      const overlayElement = this.querySelector('#CartDrawer-Overlay');
      if (overlayElement) {
        overlayElement.removeEventListener('click', this.close.bind(this));
        overlayElement.addEventListener('click', this.close.bind(this));
      }
    });

    observer.observe(this, { childList: true, subtree: true });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    const url = new URL(location);
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    if (location.href.indexOf('cartOpen=true') == -1) {
      url.searchParams.set("cartOpen", "true");
      if(!this.dataset.templateName == 'order') {
        window.history.pushState({ 'cart': 'open' }, "", url);
      }
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.style.overflow = 'hidden';
  }

  close() {
    let currentPageUrl = window.location.href.replace(/[?&]cartOpen=true/g, '');
      if(!this.dataset.templateName == 'order') {
        window.history.replaceState({}, document.title, currentPageUrl);
      }
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = 'auto';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, preorder) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    const delay = preorder ? 4500 : 0;
    if (this.getAttribute("data-auto-open") == 'true'){
      setTimeout(() => this.open(), delay);    
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  connectedCallback() {
    let cartQuantity = parseInt(this.getAttribute("data-cart-quantity"));
    if (this.getAttribute("data-enable-confetti")=="true") {
      if (cartQuantity == 1) {
        localStorage.setItem('firstCartconfetti', 'false');
      }
      if (cartQuantity == 2 && localStorage.getItem('firstCartconfetti') != 'true' ) {
        setTimeout(()=>  window.confettiShooter(),1000);
        localStorage.setItem('firstCartconfetti', 'true');
      }
      if (cartQuantity == 3) {
        localStorage.setItem('secondCartconfetti', 'false');
        localStorage.setItem('firstCartconfetti', 'true');
      }
      if (cartQuantity == 4 && localStorage.getItem('secondCartconfetti') != 'true' ) {
        setTimeout(()=>  window.confettiShooter(),1000);
        localStorage.setItem('firstCartconfetti', 'true');
        localStorage.setItem('secondCartconfetti', 'true');
      }
    }
  }
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);